import React from "react";

import { WarningMessage } from "@conversation-panel/warning";
import { CHAT_MESSAGE_STATUS } from "@/utils/constants";
import { formatChatDate } from "@/utils/helpers";

import { useMessageLogic } from "./message.hook";
import { STATUS_ICONS } from "./utils/message.constants";

import type { TMessageConfig } from "./message.types";

import * as S from "./message.styles";

const Message = React.memo(React.forwardRef<HTMLDivElement, TMessageConfig>(
  (
    {
      data,
      itsMyMessage = false,
      children,
      status = undefined,
      renderInfoBlock = true,
    },
    ref,
  ) => {
    const { today } = useMessageLogic();

    return (
      <S.Message data-qa="chat-message" itsMyMessage={itsMyMessage}>
        {children}
        <S.WrapperBalloonAndOption
          itsMyMessage={itsMyMessage}
          hasVehicleInfo={children}
        >
          <S.Balloon
            ref={ref}
            itsMyMessage={itsMyMessage}
            hasVehicleInfo={children}
          >
            <span className="wrapper__content">{data.message}</span>

            {data.fraudWarning && !itsMyMessage && (
              <WarningMessage
                newChat
                key={`warning-message-${data.senderId}-${data.sentOn}`}
              />
            )}

            {renderInfoBlock && (
              <S.Info itsMyMessage={itsMyMessage}>
                {itsMyMessage && (
                  <S.Status>
                    {STATUS_ICONS[status as keyof typeof CHAT_MESSAGE_STATUS] ||
                      STATUS_ICONS[CHAT_MESSAGE_STATUS.sending]}
                  </S.Status>
                )}
                <time dateTime={data.sentOn}>
                  {formatChatDate(data?.sentOn ?? '', today)}
                </time>
              </S.Info>
            )}
          </S.Balloon>
        </S.WrapperBalloonAndOption>
      </S.Message>
    );
  },
));

Message.displayName = "Message";
export { Message };
